import { z } from 'zod';

// `webSearches` counts `web_search` tool calls, billed at a flat blended Data-Credit rate.
export const aiUsageSchema = z.object({
  inputTokens: z.number().int().min(0),
  outputTokens: z.number().int().min(0),
  webSearches: z.number().int().min(0),
});
export type AiUsage = z.infer<typeof aiUsageSchema>;
